export default {
  ChannelManagement: {
    Header: {
      ps0: 'Starting API test...  ',
      ps1: ', Current SKU count: ',
      ps2: ', current order count: ',
      ps3: ', number of orders meeting fetching criteria: ',
      api: 'API TESTING',
      method: 'Channel',
      shop: 'Store',
      type: 'Shop Type',
      Parent: 'Parent company',
      status: 'Channel Warehouse Status',
      Name: 'Channel Warehouse Name',
      Store: 'Store Status',
      Authorization: 'Authorization Status',
      New: 'Add Online Store',
      empower: 'Authorization',

      taxCode: 'Duty Paragraph',
      accountCode: 'Account Code',
      currency: 'Currency',
      autoTableStatus: 'Whether it is an automatic order',
      shippingCostAutoStatus: 'Whether there is a courier note for the order',
      project: 'Project',
      typeOfFreight: 'Type of freight',
      one: 'Default Shipping Warehouse',
      two: 'Designated Shipping Warehouse',
      thr: 'Shipping Warehouse',
    },
    Main: {
      code: 'Online Store Code',
      name: 'Online Store Name',
      channel: 'Sales Channel',
      Parent: 'Parent company',
      status: 'Authorization Status',
      time: 'Authorization Time',
      expiration: 'Authorization Expiration Time',
      store: 'Online Store Type',
      Nam: 'Channel Warehouse Name',
      statu: 'Channel Warehouse Status',
      sta: 'Store Status',
      Creator: 'Created By',
      Creation: 'Date Created',
      Associated: 'Associated Store',
      products: 'Automatically Download Products',
      orders: 'Automatically Download Orders',
      inventory: 'Automatically Sync Inventory',
      Operate: 'Action',
      she: 'Online Store Settings',
      shipment: 'Automatically Confirm Shipment',
      Day: 'Day',
      ps: 'Please enter the number of days for automatic confirmation of shipment',
      ps1: 'Please select automatic product download',
      ps2: 'Please enter online store name',
      ps3: 'The shop has been authorized',
      ps4: 'Disable Authorization',
      ps5: 'Restore Authorization',
      ps6: 'Do you Confirm this action?',
      ps7: 'Delete ?',
      ps8: 'Enabled status, cannot be deleted',
      ps9: 'Saved successfully',
      ps91: 'Operation succeeded',
      distribution: 'Logistics Distribution',
      productPrice: 'Product Price',
      innerSkuCode: 'Platform SKU Code',
      oldPrice: 'Historical Price',
      price: 'Current Price',
      newPrice: 'Future Price',
      updatePriceTime: 'Effective Time',
      fileName: 'Online Store Product Price Management',
      errorMsg1: 'Platform SKU Code cannot be empty',
      errorMsg2: 'Current Price must be filled in, or both Future Price and Effective Time must be filled in',
      errorMsg3: 'Future Price and Effective Time must exist together',
      errorMsg4: 'Please fill in the complete table data',
      fileErrorMsg1: 'Data imported from Excel is missing, please validate before importing!',
      fileErrorMsg2: 'Duplicate data exists, please handle it before importing',
      fileErrorMsg3: 'Does not exist in the system, please check if the imported Platform SKU Code is correct！',
    },
    new: {
      shop: 'Add Store',
      editShop: 'Edit Store',
      title: 'Store Information',
      name: 'Online Store Name',
      code: 'Online Store Code',
      Channel: 'Channel Type',
      Type: 'Online Store Type',
      charge: 'Person in Charge',
      company: 'parent company',
      Invoice: 'Invoice Type',
      Associated: 'Associated Store',
      describe: 'Description',
      relateWarehouse: 'Relate Channel Warehouse',
      warehouse: 'Channel Warehouse',
      Warehousename: 'Channel Warehouse Name',
      Store: 'Shop Configuration',
      products: 'Automatically Download Products',
      orders: 'Automatically Download Orders',
      inventory: 'Automatically Sync Inventory',
      security: 'Synchronization Safety Value',
      Note: 'Note: If inventory is less than or equal to the safety value, synchronize 0 and do not call the "off-shelf" API.',
      edit: 'Edit Online Store',
      NEW: 'New Store',
      ps: 'Please enter online store name',
      ps1: 'Please select channel type',
      ps2: 'Please select online store type',
      ps3: 'Please enter person in charge',
      ps4: 'Please select parent company',
      ps5: 'Please select invoice type',
      ps6: 'Please enter online store address',
      ps7: 'Please select channel warehouse',
      ps8: 'Please enter the channel warehouse name',
    },
    Footer: {
      title: '库存超卖限制',
      total: '每个比例虚仓能连接的所有渠道仓的比例总数不超过',
      The: '*每个实仓能连接的所有比例虚仓的比例总数等于100%',
    },
    csg: {
      name: 'Store name',
      shopify: {
        appKey: 'API Key',
        appSecret: 'API Password',
        apiServiceUrl: 'Store URL',
        appKey1: 'APP ID',
        appSecret1: 'APP SECRET',
      },
      wooCommerce: {
        appKey: 'Consumer key',
        appSecret: 'Consumer secret',
        apiServiceUrl: 'Store URL',
      },
      magento: {
        appKey: 'Magento username',
        appSecret: 'API password',
        apiServiceUrl: 'Store URL',
        bpCode: 'Warehouse ID'
      },
      cin7: {
        appKey: 'API Username',
        appSecret: 'Connection Key',
        apiServiceUrl: 'Store URL',
        bpCode: 'Warehouse ID',
      },
      cin7Core: {
        appKey: 'Account ID',
        appSecret: 'Key',
      },
      maropost: {
        appKey: 'Maropost username',
        appKeyNew: 'Username',
        appSecret: 'API password',
        apiServiceUrl: 'Store URL',
        bpCode: 'Warehouse ID',
      },
      channelAdvisor: {
        appKey: 'Client ID',
        appSecret: 'Client secret',
        authAccount: 'Refresh Token',
        accountCode: 'Profile ID',
        project: 'Distribution center ID',
        WhetherGoods: 'Shipping Insurance',
        PleaseNote: 'Please note: Turning on the shipping insurance function will add additional shipping charges'
      },
      edi: {
        Retailer: 'Retailer',
      }

    },
    cron: {
      orderConfig: 'Store Order Configuration',
      CardType: 'Order On Hold',
      cardOrder: 'Hourly Order Stuck',
      cardSheet: 'Date-Specific Order Stuck',
      ForeverStuck: 'Permanent Order Stuck',
      Hour: 'Hour',
      Day: 'Day',
      Week: 'Week',
      AnyHour: 'Any hour',
      CycleFrom: 'Period From',
      Specify: 'Specific',
      AnyWeek: 'Any Week',
      AnyDay: 'Any Day',
      CycleFromWeek: 'Period From Week',
      MultipleChoices: 'Multiple selections',
      WhetherSkipWeekend: 'Whether to skip the weekend',
      Monday: 'Monday',
      Tuesday: 'Tuesday',
      Wednesday: 'Wednesday',
      Thursday: 'Thursday',
      Friday: 'Friday',
      Saturday: 'Saturday',
      Sunday: 'Sunday'
    }
  },
};
